export class PaymentMethodMapping {
  id?: number;
  ttPaymentMethodId: number;
  strPaymentMethod: string;
  pmsPayTypeId: number;
  pmsPaymentType: string;
  status: boolean;
  strStatus?: string;
  practiceId: number;
  customerId?: number;
}

export class PaymentMethodMappingReqCommand {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  PracticeId: number;
  CustomerId: number;
}

export class PaymentMethodMappingListResp {
  patientList: PaymentMethodMapping[] = [];
  totalRecords: number = 0;
}
